import * as React from "react";
const SvgMinutes = (props) => /* @__PURE__ */ React.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "40px",
	height: "40px",
	viewBox: "0 0 40 40",
	...props
}, /* @__PURE__ */ React.createElement("path", {
	style: {
		stroke: "none",
		fillRule: "nonzero",
		fill: "rgb(100%,100%,100%)",
		fillOpacity: 1
	},
	d: "M 28 33 C 28.5 33 29 32.5625 29 32 L 29 14 L 24 14 C 22.875 14 22 13.125 22 12 L 22 7 L 12 7 C 11.4375 7 11 7.5 11 8 L 11 32 C 11 32.5625 11.4375 33 12 33 Z M 8 8 C 8 5.8125 9.75 4 12 4 L 22.3125 4 C 23.375 4 24.375 4.4375 25.125 5.1875 L 30.8125 10.875 C 31.5625 11.625 32 12.625 32 13.6875 L 32 32 C 32 34.25 30.1875 36 28 36 L 12 36 C 9.75 36 8 34.25 8 32 Z M 8 8 "
}));
export default SvgMinutes;
